/**
 * {@docCategory ResizeGroup}
 */
export var ResizeGroupDirection;
(function (ResizeGroupDirection) {
  ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
  ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
})(ResizeGroupDirection || (ResizeGroupDirection = {}));